// src/styles/mystara-system.ts
// Mystara Design System — Shared style constants

export const mystara = {
  // Backgrounds
  pageBg: "bg-gradient-to-br from-pink-100/40 via-purple-50/40 to-cyan-50/40",

  // Glass panels (main containers)
  glassPanel: `
    bg-white/20
    backdrop-blur-xl
    border border-white/40
    rounded-2xl
    shadow-lg shadow-purple-500/5
  `.trim().replace(/\s+/g, ' '),

  // Glass cards (smaller elements inside panels)
  glassCard: `
    bg-white/30
    backdrop-blur-md
    border border-white/50
    rounded-xl
    shadow-sm
    hover:bg-white/40
    hover:shadow-md
    hover:border-white/60
    transition-all duration-200
  `.trim().replace(/\s+/g, ' '),

  // Tool header
  toolHeader: `
    flex items-center justify-between
    px-6 py-4
    border-b border-white/20
  `.trim().replace(/\s+/g, ' '),

  // Primary button (main actions)
  primaryButton: `
    px-5 py-2.5
    bg-gradient-to-r from-purple-500 to-pink-500
    text-white font-medium
    rounded-xl
    shadow-md shadow-purple-500/20
    hover:shadow-lg hover:shadow-purple-500/30
    hover:scale-[1.02]
    active:scale-[0.98]
    transition-all duration-200
  `.trim().replace(/\s+/g, ' '),

  // Secondary button (less prominent actions)
  secondaryButton: `
    px-4 py-2
    bg-white/40
    text-purple-700 font-medium
    rounded-xl
    border border-white/50
    hover:bg-white/60
    hover:border-purple-200
    transition-all duration-200
  `.trim().replace(/\s+/g, ' '),

  // Ghost button (minimal, for back buttons etc)
  ghostButton: `
    px-3 py-2
    text-purple-600
    rounded-xl
    hover:bg-white/30
    transition-all duration-200
  `.trim().replace(/\s+/g, ' '),

  // Input fields
  input: `
    w-full px-4 py-3
    bg-white/40
    border border-white/50
    rounded-xl
    text-purple-800
    placeholder:text-purple-400
    focus:outline-none
    focus:border-purple-300
    focus:bg-white/50
    focus:ring-2 focus:ring-purple-200/50
    transition-all duration-200
  `.trim().replace(/\s+/g, ' '),

  // Text styles
  textHeading: "text-purple-800 font-semibold",
  textBody: "text-purple-700",
  textMuted: "text-purple-500",
  textAccent: "text-purple-600",

  // Category accent colors (subtle, for tinting glass cards)
  categoryAccents: {
    identity: "from-purple-100/60 to-purple-50/40 border-purple-200/50",
    abundance: "from-amber-100/60 to-amber-50/40 border-amber-200/50",
    love: "from-pink-100/60 to-pink-50/40 border-pink-200/50",
    confidence: "from-orange-100/60 to-orange-50/40 border-orange-200/50",
    health: "from-green-100/60 to-green-50/40 border-green-200/50",
    success: "from-cyan-100/60 to-cyan-50/40 border-cyan-200/50",
  },

  // Icon container (for consistent icon presentation)
  iconBubble: `
    w-10 h-10
    rounded-full
    bg-white/50
    flex items-center justify-center
    border border-white/60
  `.trim().replace(/\s+/g, ' '),
};

export default mystara;
